import type { Router } from 'vue-router'
import { canNavigate } from '@layouts/plugins/casl'

// 역할 기반 홈 경로 결정
const getHomeRouteForUser = (): string => {
  const userDataStr = localStorage.getItem('userData')
  if (!userDataStr)
    return '/login'

  try {
    const userData = JSON.parse(userDataStr)
    const roles = userData?.roles || []

    // 리글 텔레마케터는 스캔 페이지로
    if (roles.includes('regle-telemarketer'))
      return '/review/scan'

    // 기본적으로 대시보드로
    return '/regle/dashboard'
  }
  catch {
    return '/login'
  }
}

export const setupGuards = (router: Router) => {
  // 👉 router.beforeEach
  // Docs: https://router.vuejs.org/guide/advanced/navigation-guards.html#global-before-guards
  router.beforeEach(to => {
    /*
     * If it's a public route, continue navigation. This kind of pages are allowed to visited by login & non-login users. Basically, without any restrictions.
     * Examples of public routes are, 404, under maintenance, etc.
     */
    if (to.meta.public)
      return

    /**
     * Check if user is logged in by checking if token & user data exists in local storage
     * Feel free to update this logic to suit your needs
     */
    const isLoggedIn = !!(localStorage.getItem('userData') && localStorage.getItem('accessToken'))

    /*
      If user is logged in and is trying to access login like page, redirect to home
      else allow visiting the page
      (WARN: Don't allow executing further by return statement because next code will check for permissions)
     */
    if (to.meta.unauthenticatedOnly) {
      if (isLoggedIn)
        return getHomeRouteForUser()
      else
        return undefined
    }

    if (!canNavigate(to) && to.matched.length) {
      return isLoggedIn
        ? { name: 'not-authorized' }
        : {
          name: 'login',
          query: {
            ...to.query,
            to: to.fullPath !== '/' ? to.path : undefined,
          },
        }
    }
  })
}
